import React from 'react';
import { useAdminAccess } from 'contexts/adminAccess';

import Switch from 'components/fields/Switch';
import { RewardBenefitDto, RewardLevelDto } from '../../types';

interface SwitchFieldProps {
  benefit: RewardBenefitDto;
  levelId?: RewardLevelDto['id'];
  loading?: boolean;
  onToggle: (benefit: RewardBenefitDto, levelId?: RewardLevelDto['id']) => void;
}

const SwitchField = ({ benefit, levelId, loading, onToggle }: SwitchFieldProps) => {
  const { canWrite } = useAdminAccess();
  return (
    <Switch
      checked={Boolean(benefit?.levels?.includes(levelId))}
      onChange={() => onToggle(benefit, levelId)}
      color="primary"
      disabled={!canWrite || !benefit?.id || !levelId || loading}
    />
  );
};

export default SwitchField;
